import { STATE_LOCATION, STATE_ORDER_DRIVER } from "../../Constants/actionTypes";

export interface AuthState {
  authData: any;
  userMenu: any[];
  stateLocation: any;
  stateOrderDriver: Record<string, any>;
  fetchApi: boolean;
}

const initialState: AuthState = {
  authData: null,
  userMenu: [],
  stateLocation: null,
  stateOrderDriver: {},
  fetchApi: true,
};

const authReducer = (state = initialState, action: any): AuthState => {
  switch (action.type) {
    case STATE_LOCATION:
      return { ...state, stateLocation: action.payload };
    case STATE_ORDER_DRIVER:
      return { ...state, stateOrderDriver: action.payload };
    default:
      return state;
  }
};

export default authReducer;
